import React, { useState, useRef, useEffect } from "react";
import { BsReply } from "react-icons/bs";
import gsap from "gsap";
import { Draggable } from "gsap/Draggable";
import ExpandableText from "../chat/ExpandableText";
import "./chat-video-messages.css";

gsap.registerPlugin(Draggable);

const SWIPE_THRESHOLD = 50;

export default function MessageVideo({
  position,
  message,
  peer,
  keyId,
  replyTo,
  onSwipeReply,
  msgObject,
}) {
  const [imageError, setImageError] = useState(false);
  const rowRef = useRef(null);
  const indicatorRef = useRef(null);

  const isRight = position === "right";

  useEffect(() => {
    if (!rowRef.current || !onSwipeReply) return;

    const el = rowRef.current;
    const drag = Draggable.create(el, {
      type: "x",
      bounds: { minX: 0, maxX: 80 },
      edgeResistance: 0.85,
      onDrag() {
        const x = this.x;
        if (indicatorRef.current) {
          indicatorRef.current.style.opacity = Math.min(x / SWIPE_THRESHOLD, 1);
        }
      },
      onDragEnd() {
        const x = this.x;
        if (x >= SWIPE_THRESHOLD && msgObject) {
          onSwipeReply(msgObject);
        }
        gsap.to(el, { x: 0, duration: 0.25, ease: "power2.out" });
        if (indicatorRef.current) {
          gsap.to(indicatorRef.current, {
            opacity: 0,
            duration: 0.2,
          });
        }
      },
    })[0];

    return () => drag.kill();
  }, [onSwipeReply, msgObject]);

  const avatarBlock = (
    <div className="message-video-avatar-col">
      {peer.userImage && !imageError ? (
        <img
          className="message-video-avatar"
          src={peer.userImage}
          alt=""
          onError={() => setImageError(true)}
        />
      ) : (
        <div
          className="message-video-avatar-initials"
          style={{
            backgroundColor: peer.colors?.background || "#3c4043",
            color: peer.colors?.text || "#fff",
          }}
        >
          {peer.displayName?.charAt(0)}
          {peer.displayName?.split(" ")[1]?.charAt(0)}
        </div>
      )}
      {!isRight && (
        <div className="message-video-sender">
          {peer.displayName?.split(" ")[0]}
        </div>
      )}
    </div>
  );

  return (
    <div style={{ position: "relative", overflow: "hidden" }}>
      {/* Reply icon (revealed on swipe) */}
      <div ref={indicatorRef} className="message-video-swipe-indicator">
        <BsReply />
      </div>

      <div
        ref={rowRef}
        id={keyId}
        key={keyId}
        className="message-video-row d-flex"
        style={{
          flexDirection: isRight ? "row-reverse" : "row",
          gap: "6px",
          alignItems: "flex-start",
          touchAction: "pan-y",
          userSelect: "none",
        }}
      >
        {avatarBlock}

        <div style={{ maxWidth: "260px" }}>
          {replyTo && (
            <div className="message-video-reply-quote">
              <span className="message-video-reply-author">
                {replyTo.sender?.displayName?.split(" ")[0]}
              </span>
              <span className="message-video-reply-text">
                {replyTo.contenu?.length > 60
                  ? replyTo.contenu.slice(0, 60) + "..."
                  : replyTo.contenu}
              </span>
            </div>
          )}
          <div
            className={`message-box message__box__chat__video__${
              isRight ? "right" : "left"
            }`}
          >
            <ExpandableText>
              <p>{message}</p>
            </ExpandableText>
          </div>
        </div>
      </div>
    </div>
  );
}
